import React from "react";

const TermsAndConditions = () => {
  return (
    <section className="inner-page">
      <div className="container">
        <h1>IT Assist Experts Terms & Conditions</h1>
        <p>
          These terms govern your use of the IT Assist Experts website and the
          assistance services requested through it. By using this website or
          submitting a request, you agree to use the site lawfully and to provide
          accurate contact information.
        </p>
        <h2>Services</h2>
        <p>
          IT Assist Experts provides technology assistance for laptops,
          desktops, printers, software, networks, and related devices. Service
          availability, pricing, response times, and outcomes may vary depending
          on the issue, device condition, location, and information provided by
          the customer.
        </p>
        <h2>Customer Responsibilities</h2>
        <p>
          You are responsible for backing up important data before any service
          begins, confirming that you have authorization to request help for the
          device or account involved, and following any instructions required to
          complete remote or on-site assistance.
        </p>
        <h2>Payments and Offers</h2>
        <p>
          Prices, offers, plans, and product information shown on this website
          are subject to change. Any final service scope or purchase details
          should be confirmed with IT Assist Experts before payment.
        </p>
        <h2>Third-Party Products</h2>
        <p>
          IT Assist Experts is an independent assistance provider. References to
          third-party brands, devices, software, or services are for
          compatibility and service-description purposes only and do not imply
          affiliation or endorsement.
        </p>
        <h2>Contact</h2>
        <p>
          Questions about these terms can be sent to
          support@itassistexperts.com.
        </p>
      </div>
    </section>
  );
};

export default TermsAndConditions;
